import React, { Component } from 'react';
import { Layer } from 'react-konva';
import {bindActionCreators, Dispatch} from 'redux';
import { connect } from 'react-redux';
import _chunk from 'lodash/chunk';
import {
  ILaid,
  ICardsRenderInfo,
  DropFromLaidToLaidPayload,
  LaidSlotsDropPayload, DropFromLaidToHomePayload, SuperMove, RecordState
} from '../../redux/types';
import Pile from './Pile';
import { IDropElement } from '../../functions/hints';
import {
  dropFromLaidToHome, dropFromLaidToLaid, dropFromLaidToSlots, setListening,
  showCardsOverflowMessage,
} from "../../redux/actions";

interface ILaidProps {
  laidData: ILaid,
  cardParameters: ICardsRenderInfo,
  dropElements: IDropElement[],
  listening: boolean,
  superMove: SuperMove | false,
  numberOfEmptyPiles: number,
  numberOfEmptySlots: number,
  size: number,
  actions: {
    dropFromLaidToLaid: (param: DropFromLaidToLaidPayload) => void
    dropFromLaidToSlots: (param: LaidSlotsDropPayload) => void,
    dropFromLaidToHome: (param: DropFromLaidToHomePayload) => void,
    setListening: (listening: boolean) => void,
    showCardsOverflowMessage: (visible: boolean, maxCards: number, needCards: number) => void,
  },
}

class Laid extends Component<ILaidProps, {}> {
  render() {
    const {
      laidData, dropElements, actions, listening, superMove, cardParameters,
      numberOfEmptyPiles, numberOfEmptySlots, size,
    } = this.props;

    const data = _chunk(laidData, laidData.length / 2);
    return (
      <>
        {data.map((chunk, index) => {
          return (
            <Layer listening={listening} key={`Laid-Chunk-${index}`}>
              {chunk.map((pile, index2) => {
                return (
                  <Pile
                    index={index2 + (index * 4)}
                    key={`Pile-${index2}`}
                    pileData={pile}
                    dropElements={dropElements}
                    actions={actions}
                    superMove={superMove}
                    cardParameters={cardParameters}
                    numberOfEmptyPiles={numberOfEmptyPiles}
                    numberOfEmptySlots={numberOfEmptySlots}
                    size={size}
                  />
                )
              })}
            </Layer>
          )
        })}
      </>
    );
  }
}

function mapStateToProps(state: RecordState) {
  return {
    laidData: state.getIn(['gameState', 'laid']),
    dropElements: state.get('dropElements'),
    listening: state.getIn(['settings', 'listening']),
    superMove: state.getIn(['settings', 'superMove']),
    cardParameters: state.get('cardsRenderInfo'),
    numberOfEmptyPiles: state.get('numberOfEmptyPiles'),
    numberOfEmptySlots: state.get('numberOfEmptySlots'),
    size: state.get('size'),
  }
}

function mapDispatchToProps(dispatch: Dispatch) {
 return {
   actions: {
     dropFromLaidToLaid: bindActionCreators(dropFromLaidToLaid, dispatch),
     dropFromLaidToSlots: bindActionCreators(dropFromLaidToSlots, dispatch),
     dropFromLaidToHome: bindActionCreators(dropFromLaidToHome, dispatch),
     setListening: bindActionCreators(setListening, dispatch),
     showCardsOverflowMessage: bindActionCreators(showCardsOverflowMessage, dispatch),
   },
 }
}

export default connect(mapStateToProps, mapDispatchToProps)(Laid);
